//axios在收到指令执行任务所需要的所有信息都来自于store，因而各个来源的数据都需要存入store中，即：
//各component在操作后的结果都会存入store中；
//通过href执行任务那么href中的信息首先存入store中；
//搜索框的信息存入store中；
//server中的参数和store中的参数有不一定全部相等，故而列出一一对应；
import store from '../store'
//serverparams和storeval的顺序要一一对应
let serverparams =
    ["collection", "matchrule", "target", "page", "sortset", "fdata", "filtercode", "ids", "tag", "collectionobj", "apiparams", "searchmodel", "splittarget", "splitfixed", "sumitem","urlbeforesplit","splituniques","splittimemodel","theevalforsplit","xfield","yvalues","timemodel","chartmodel"]
let storeval =
    ["clct", "matchrule", "targettxt", "page", "sortset", "filter", "filtercode", "fetchids", "fetchidstag", "collection", "apiparams", "searchmodelthattime", "splittarget", "splitfixed", "sumitem","urlbeforesplit","splituniques","splittimemodel","theevalforsplit","xfield","yvalues","timemodel","chartmodel"]


let modelparamms = {
    filter: ["collection", "matchrule", "fdata", "page", "sortset"],
    generalsearch: ["collection", "matchrule", "target", "page", "sortset"],
    rawcodefilter: ["collection", "matchrule", "filtercode", "page", "sortset"],
    fetchbyids: ["collection", "matchrule", "ids", "tag", "sortset","page"],
    apisearch: ["collection", "collectionobj", "apiparams"],
    getsplituniques: ["collection", "searchmodel", "target", "fdata", "ids", "splittarget"],
    splitfield: ["collection", "searchmodel", "target", "fdata", "ids", "splittarget", "splitfixed", "sumitem","urlbeforesplit","splituniques","splittimemodel","theevalforsplit"],
    chartparams:["collection", "searchmodel", "target", "fdata", "ids","chartmodel", "xfield","yvalues","timemodel"]
}


//从store中获取相应searchmodel的param用于fetchdata
function getparamsfromstore(thesearchmodel) {
    let resultparams = {}
    let requiredparam = modelparamms[thesearchmodel]

    serverparams.forEach((val, i) => {
        if (requiredparam.includes(val)) {
            resultparams[val] = storevalprocess(storeval[i])
        }
    })

    return resultparams
}

//从params中提取值存入store
function setparamstostore(thesearchmodel, paramobj) {
    let resultparams = {}
    let requiredparam = modelparamms[thesearchmodel]

    serverparams.forEach((val, i) => {
        if (paramobj[val] && requiredparam.includes(val)) {//&& iftostore(thesearchmodel, val)
            resultparams[storeval[i]] = paramprocess(thesearchmodel, paramobj, val)
        }
    })


    //根据一一对应关系设置state
    store.commit("batchset", resultparams)

    //由于batchset中只设置了clct,但还需要通过setcollectionbyval进行判断和设置，因为setcollectionbyval带有判断collection的功能，判断其是否在可查找范围内
    store.commit("setcollectionbyval", store.state.clct)


}






//通过href提取值存入store
//从href中提取searchmodel和query信息,superextra为手动传入的param，将会替换href中的param
function hrefinfotostore(href) {

    //从href中获取信息
    let paramobj = decodeurl(href)

    //如果url里有param那么设置
    if (paramobj) {
        let searchmodel
        let query

        searchmodel = paramobj.searchmodel
        //href中的param
        query = paramobj.query

        //store中本来就有的param
        let currentstoreparam = getparamsfromstore(searchmodel)

        //将href中和store中的param合并，如果href中提取有参数，那么是用href中提取的，如果没有，那么就用store中的
        Object.assign(currentstoreparam, query)


        //重置store
        store.commit("reset")
        store.commit("setsearchmodel", searchmodel)
        
        setparamstostore(searchmodel, currentstoreparam)
        
 

    }

    //如果param中没有，那么读取上次的
    else {
        store.commit("setcollectionbyval", store.state.clct)
    }

}





//将href存入storeage和store的history
function tostorehrefinhistory(href) {
    let history = store.state.history
    history.unshift(href)
    let uniqhistory = [...new Set(history)]
    uniqhistory.splice(10, 100000)//仅仅保留前10个
    // console.log(uniqhistory)
    store.commit("sethistory", uniqhistory)
}

//将query数据存入href
function generateurl(query) {
    let params = JSON.parse(JSON.stringify(query))
    //判断，有些params不计入url中，取消，直接在href中手动设置
    // for (let k in params) {
    //     if (iftoparams(store.state.searchmodel, k) == false) {
    //         delete params[k]
    //     }
    // }
    window.location.href = tomakeurl(params, store.state.searchmodel)
    tostorehrefinhistory(window.location.href)
}


// function iftoparams(searchmodel, val) {
//     //"target","fdata","ids"这三个生成params不存放在href中
//     if (searchmodel == "splitfield") {
//         if (["searchmodel", "target", "fdata", "ids"].includes(val)) {
//             return false
//         }
//         else {
//             return true
//         }

//     }
//     else {
//         return true
//     }
// }

//将store中的信息存入targettxt(搜索框)
function searchinfo(model) {
    switch (model) {
        case "filter":
            store.commit("settargettxt", JSON.stringify(store.state.filter));
            break;
        case "apisearch":
            let apisearchinfo = { apisearch: store.state.apiparams }
            store.commit("settargettxt", JSON.stringify(apisearchinfo));
            break;
        case "rawcodefilter":
            store.commit("settargettxt", "{rawcodefilter:" + store.state.filtercode + "}");
            break;
        case "fetchbyids":
            store.commit("settargettxt", store.state.fetchidstag);
            break;

    }

}

//从targettxt中的信息提取到store
function extractinfofromtxt() {
    let targettxt = store.state.targettxt || ""

    if (targettxt.includes("{") && !targettxt.includes("{rawcodefilter") && !targettxt.includes('{"apisearch')) {
        try {
            let filter = JSON.parse(targettxt)
            store.commit("setfilter", filter)
            store.commit("setsearchmodel", "filter")
        }
        catch (e) {
            store.commit("setsearchmodel", "generalsearch")
        }
    }
    else if (targettxt.includes('{"apisearch')) {
        try {
            let apisearchinfo = JSON.parse(targettxt)
            store.commit("setapiparams", apisearchinfo.apisearch);
            store.commit("setsearchmodel", "apisearch")
        }
        catch (e) {
            // store.commit("setsearchmodel", "generalsearch")
        }
    }
    else if (targettxt.includes("{rawcodefilter")) {

        //当tragettxt如：{rawcodefilter:theagg={$project:{from:1,to:1}}}
        let filtercode = targettxt.slice(15, -1)
        // console.log(filtercode)
        store.commit("setsearchmodel", "rawcodefilter")
        store.commit("setfiltercode", filtercode)
    }
}




function paramprocess(searchmodel, obj, k) {
    let product
    product = obj[k]
    switch (k) {
        case "page":
            product = parseInt(product)
            break;
        case "sortset":
            for (let x in product) {
                product[x] = parseInt(product[x])
            }
            break;
        case "fdata":
            //该语句用于检查filter中是否有object，如果有，那就是daterange的array转换成的，需要将其转换为数组
            try {
                for (let x in product) {
                    if (typeof product[x] === 'object') {
                        let ar = []
                        for (let y in product[x]) {
                            ar.push(product[x][y])
                        }
                        product[x] = ar
                    }
                }
            }
            catch (e) { };
            break;

    }




    return product
}

function storevalprocess(key) {
    let product
    product = store.state[key]

    // switch (key) {
    if (key == "filter") {
        product = nullremover(store.state.filter);
    }

    //如果searchmodelthattime未设置(这种情况发生在读取URL时，因href并不储存searchmodelthattime)，那么当前的searchmodel就是当时的searchmodel
    if (key == "searchmodelthattime") {
        // console.log("aaaaaa" + product)
        if (!product) {
            // console.log("bbbbb" + product)
            product = store.state.searchmodel
        }
    }
    // }


    return product
}

//将filter中的null值删除
function nullremover(obj) {
    let fdata = JSON.parse(JSON.stringify(obj))
    for (let key in fdata) {
        if (fdata[key] === null || fdata[key] === "") {
            delete fdata[key]
        }
    }
    return fdata
}


function decodeurl(href) {
    let objparameter = null
    let modelpos = href.lastIndexOf("##")

    let querypos = href.lastIndexOf("??")

    if (modelpos > 0 && querypos > 0) {
        try {
            let searchmodel = href.substring(modelpos + 2, querypos)

            let query = href.substring(querypos + 2)

            // query = JSON.parse('{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            query = getParamsAsObject(query)
            objparameter = { searchmodel: searchmodel, query: query }


        }
        catch (error) {
            return false
        }
    }
    return objparameter

};




function tomakeurl(query, model) {
    let thehref = window.location.href
    thehref = thehref.substring(0, thehref.lastIndexOf("###"))
    return thehref + "###" + model + "??" + serialiseObject(query)
}





//https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
function getParamsAsObject(query) {

    query = query.substring(query.indexOf('?') + 1);

    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g;

    var decode = function (str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };


    var params = {}, e;
    while (e = re.exec(query)) {
        var k = decode(e[1]), v = decode(e[2]);
        if (k.substring(k.length - 2) === '[]') {
            k = k.substring(0, k.length - 2);
            (params[k] || (params[k] = [])).push(v);
        }
        else params[k] = v;
    }

    var assign = function (obj, keyPath, value) {
        var lastKeyIndex = keyPath.length - 1;
        for (var i = 0; i < lastKeyIndex; ++i) {
            var key = keyPath[i];
            if (!(key in obj))
                obj[key] = {}
            obj = obj[key];
        }
        obj[keyPath[lastKeyIndex]] = value;
    }

    for (var prop in params) {
        var structure = prop.split('[');
        if (structure.length > 1) {
            var levels = [];
            structure.forEach(function (item, i) {
                var key = item.replace(/[?[\]\\]/g, '');
                levels.push(key);
            });
            assign(params, levels, params[prop]);
            delete (params[prop]);
        }
    }
    return params;
};


function serialiseObject(obj, prefix) {
    return $.param(obj)
}

export { hrefinfotostore, generateurl, tomakeurl, getparamsfromstore, searchinfo, extractinfofromtxt };


// WEBPACK FOOTER //
// ./src/axios/objparamobj.js